import { makeStyles } from "tss-react/mui";

export const useNWONFaqStyles = makeStyles()((theme) => ({
  accordion: {
    width: "100%",
    background: theme.palette.common.white,
    "& .Mui-expanded": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    borderRadius: "0!important",
  },
  accordionSummary: {
    borderRadius: "0!important",
    fontWeight: theme.typography.fontWeightBold,
  },
}));
